import { Component, OnInit } from '@angular/core';
import { InputBase } from '../../../common/api/common/InputBase';
import { ProjectDocPrintInput } from '../../../common/api/ProjectDocPrint';
import { TranslateService } from "../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { GlobalService } from "../../../common/services/global.service";
import { SC_Input } from '../../../common/input/SC_Input';
import { DocAddressData } from '../../../common/api/DocAddressGet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TypeOptions } from '../../../common/api/common/TypeOptions';

@Component({
  selector: 'sen-app-print-system-documents',
  templateUrl: './print-system-documents.component.html',
  styleUrls: ['./print-system-documents.component.scss']
})
export class PrintSystemDocumentsComponent implements OnInit {
  printOptions: string[] = [];
  coverPhotoBlob: Blob;
  apiOptions: ProjectDocPrintInput = {
    projectID: SC_Input.sProject.selectedProject.id,
    owner: new DocAddressData,
    editor: new DocAddressData,
    installer: new DocAddressData,
    options: new TypeOptions,
    image: new Blob
  }

  constructor(public translate: TranslateService, private _snackBar: MatSnackBar, public global: GlobalVariableService, public globalService: GlobalService) { }

  ngOnInit(): void { }

  setOptions(event: string[]) {
    this.printOptions = event;
  }

  setImageBlob(event: Blob) {
    this.coverPhotoBlob = event;
    this.apiOptions.image = event;
  }

  printPDF() {
	
    for (let i = 0; i < this.printOptions.length; i++) {
        if(this.printOptions[i] == "cover")
          this.apiOptions.options.cover = true;
        if(this.printOptions[i] == "protocol")
          this.apiOptions.options.protocol = true;    
        if(this.printOptions[i] == "roofplanoverview")
          this.apiOptions.options.roofPlanOverview = true;
        if(this.printOptions[i] == "roofplansubframe")
          this.apiOptions.options.roofPlanSubFrame = true;  
        if(this.printOptions[i] == "stringoverview")
          this.apiOptions.options.stringOverview = true;
        if(this.printOptions[i] == "subgenerators")
          this.apiOptions.options.subGenerators = true;        
        if(this.printOptions[i] == "items")
          this.apiOptions.options.items = true;                                 
    }
    // if (this.apiOptions.options.cover && !this.coverPhotoBlob) {
    //   //this._snackBar.open(this.translate.getLng('NO_PRINT_OPTION'));
    //   this._snackBar.open(this.translate.getLng('PLEASE_UPLOAD_PHOTO'));
    //   this.apiOptions.options = new TypeOptions;
    //   return;
    // }
    if (!this.printOptions.length) {
      this._snackBar.open(this.translate.getLng('PLEASE _SELECT_ATLEAST_ONE_OPTION'));
      this.apiOptions.options = new TypeOptions;
      return;
    }
    let option = this.apiOptions;

    const qParam: InputBase = {
      cmd: this.global.ProjectDocPrint
    };
    this.globalService.postData(qParam, option).subscribe(data => {
      if (data && data.ok) {
        window.open(data.ok.data.url);
      }
      this.apiOptions.options = new TypeOptions;
    });  
  }

}
